import { EspecialidadI } from "interfaces/especialidad";
import { ReactNode, useState } from "react";

interface Props {
  elemento: EspecialidadI;
  renderActions?: (elemento: EspecialidadI) => ReactNode;
}

export const EspecialidadRow = ({ elemento, renderActions }: Props) => {
  return (
    <>
      <tr className="table-row" key={`ResolucionTable-${elemento.id}`}>
        <td>{elemento.id}</td>
        <td>{elemento.nombre}</td>
        {renderActions && (
          <td style={{ maxWidth: "50px" }}>{renderActions(elemento)}</td>
        )}
      </tr>
    </>
  );
};
